module.exports = __webpack_public_path__ + "media/images/real-last-3-49d0946b8da7ea0eee9a8c1dd81ba935.png";